import * as a from "react";
import { p as l } from "./index-efd35e77.js";
import { v as M, c as k, p as w } from "./package-metadata-9ad1330d.js";
import { k as _, s as x, I as N } from "./theme-b013fa81.js";
var z = globalThis && globalThis.__extends || function() {
  var r = function(o, e) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
      t.__proto__ = n;
    } || function(t, n) {
      for (var s in n)
        Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }, r(o, e);
  };
  return function(o, e) {
    if (typeof e != "function" && e !== null)
      throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    r(o, e);
    function t() {
      this.constructor = o;
    }
    o.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
  };
}(), d = globalThis && globalThis.__assign || function() {
  return d = Object.assign || function(r) {
    for (var o, e = 1, t = arguments.length; e < t; e++) {
      o = arguments[e];
      for (var n in o)
        Object.prototype.hasOwnProperty.call(o, n) && (r[n] = o[n]);
    }
    return r;
  }, d.apply(this, arguments);
}, U = globalThis && globalThis.__rest || function(r, o) {
  var e = {};
  for (var t in r)
    Object.prototype.hasOwnProperty.call(r, t) && o.indexOf(t) < 0 && (e[t] = r[t]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, t = Object.getOwnPropertySymbols(r); n < t.length; n++)
      o.indexOf(t[n]) < 0 && Object.prototype.propertyIsEnumerable.call(r, t[n]) && (e[t[n]] = r[t[n]]);
  return e;
};
function S(r) {
  var o = r.imageUrl, e = r.name, t = r.iconClass, n = r.svgIcon, s = r.imageAlt;
  return o ? a.createElement("img", { role: "presentation", className: "k-button-icon", alt: s, src: o }) : e || n ? a.createElement(N, { className: "k-button-icon", name: e, icon: n }) : t ? a.createElement("span", { role: "presentation", className: k("k-button-icon", t) }) : null;
}
var R = (
  /** @class */
  function(r) {
    z(o, r);
    function o(e) {
      var t = r.call(this, e) || this;
      return t._element = null, t.handleClick = function(n) {
        t.toggleIfApplicable(), t.props.onClick && t.props.onClick.call(void 0, n);
      }, M(w), t.state = { selected: t.props.togglable === !0 && t.props.selected === !0 }, t;
    }
    return Object.defineProperty(o.prototype, "element", {
      /**
       * Gets the DOM element of the Button component.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(o.prototype, "selected", {
      /**
       * Returns `true` when the component is togglable and selected ([see example]({% slug toggleable_button %})).
       * Otherwise, returns `false`.
       */
      get: function() {
        return this._selectedTemp !== void 0 ? this._selectedTemp : this.state.selected;
      },
      enumerable: !1,
      configurable: !0
    }), o.getDerivedStateFromProps = function(e, t) {
      return e.togglable && e.selected !== void 0 && e.selected !== t.selected ? { selected: e.selected } : null;
    }, o.prototype.render = function() {
      var e, t = this, n = this.props, s = n.children, C = n.togglable, f = n.icon, p = n.iconClass, O = n.svgIcon, m = n.imageUrl, P = n.imageAlt;
      n.className, n.onClick;
      var g = n.size, c = g === void 0 ? o.defaultProps.size : g, h = n.rounded, u = h === void 0 ? o.defaultProps.rounded : h, b = n.fillMode, i = b === void 0 ? o.defaultProps.fillMode : b, v = n.themeColor, y = v === void 0 ? o.defaultProps.themeColor : v, T = U(n, ["children", "togglable", "icon", "iconClass", "svgIcon", "imageUrl", "imageAlt", "className", "onClick", "size", "rounded", "fillMode", "themeColor"]), I = f !== void 0 || p !== void 0 || m !== void 0, j = s !== void 0, A = S({
        name: f,
        svgIcon: O,
        iconClass: p,
        imageUrl: m,
        imageAlt: P
      });
      return a.createElement(
        "button",
        d({ ref: function(E) {
          return t._element = E;
        }, "aria-pressed": C ? this.state.selected : void 0 }, T, { onClick: this.handleClick, className: k("k-button", (e = {}, e["k-button-".concat(_.sizeMap[c] || c)] = c, e["k-button-".concat(i)] = i, e["k-button-".concat(i, "-").concat(y)] = !!(i && y), e["k-rounded-".concat(_.roundedMap[u] || u)] = u, e["k-icon-button"] = !j && I, e["k-disabled"] = this.props.disabled, e["k-selected"] = this.state.selected, e["k-rtl"] = this.props.dir === "rtl", e), this.props.className) }),
        A,
        s && a.createElement("span", { className: "k-button-text" }, s)
      );
    }, o.prototype.toggleIfApplicable = function() {
      var e = this;
      if (this.props.togglable && this.props.selected === void 0) {
        var t = !this.state.selected;
        this._selectedTemp = t, this.setState({ selected: t }, function() {
          return e._selectedTemp = void 0;
        });
      }
    }, o.propTypes = {
      children: l.node,
      selected: l.bool,
      togglable: l.bool,
      icon: l.string,
      svgIcon: x,
      iconClass: l.string,
      imageUrl: l.string,
      imageAlt: l.string,
      size: l.oneOf([null, "small", "medium", "large"]),
      rounded: l.oneOf([null, "small", "medium", "large", "full"]),
      fillMode: l.oneOf([null, "flat", "link", "outline", "solid"]),
      // eslint-disable-next-line max-len
      themeColor: l.oneOf([null, "base", "primary", "secondary", "tertiary", "info", "success", "warning", "error", "dark", "light", "inverse"])
    }, o.defaultProps = {
      togglable: !1,
      size: "medium",
      rounded: "medium",
      fillMode: "solid",
      themeColor: "base"
    }, o;
  }(a.Component)
);
export {
  R as B
};
